export const CROP_TYPE = {
  MANUAL: 'manual', // User manually cropped the image
  DEFAULT: 'default', // Calculate center crop (output of calcImageDefaultCrop())
  SMART: 'smart', // Calculate crop based on faces positions (output of calculateSmartCrop())
  FIT: 'fit', // Fit existing user crop to match different aspect ratio (output of fitCropToAllRatios())
}
